import { AccordionSummary, AccordionSummaryProps } from '@material-ui/core'
import { ReactComponent as ExpandIcon } from '../../assets/v3/icons/expand.svg'
import React from 'react'

const YumAccordionSummary = (props: AccordionSummaryProps) => (
  <AccordionSummary expandIcon={<ExpandIcon />} {...props} />
)

export default YumAccordionSummary
